export default __webpack_public_path__ + "static/media/soil_aquifer_treatment.d8f547c6.png";